import { observable } from 'mobx';

export class TextSketchInputProperties {
  @observable text: string = '';
  @observable size: number = 12;
}
